// extracted by mini-css-extract-plugin
module.exports = {"sidebar-title_2ncQ1-":"sidebar-title_2ncQ1-","title_2ZYTX9":"title_2ZYTX9"};